export function applyTilesToFocalPointAspectRatio({
  aspectRatio,
  rows,
  columns,
}: {
  aspectRatio: number;
} & Tiles): number {
  return (aspectRatio * rows) / columns;
}
